"use client";

import React, { useEffect, useState } from "react";
import { useTheme } from "next-themes";
// import { Moon, Sun } from "lucide-react";
// import { Button } from "./button";
import { KsaFlag, UkFlag } from "./flags";
import { Select, SelectContent, SelectItem, SelectTrigger } from "./select";

export interface AuthHeaderActionsProps {
  currentLanguage: string;
  onLanguageToggle: () => void;
}

export function AuthHeaderActions({ currentLanguage, onLanguageToggle }: AuthHeaderActionsProps) {
  const { setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    setTheme("light"); // Force light mode as default for auth layout
  }, [setTheme]);

  /*
  const toggleTheme = () => {
    setTheme(resolvedTheme === "dark" ? "light" : "dark");
  };
  */

  if (!mounted) return null;

  return (
    <div className="absolute top-4 inset-e-4 flex items-center gap-4 z-50">
      <Select
        value={currentLanguage}
        onValueChange={(val) => {
          if (val !== currentLanguage) {
            onLanguageToggle();
          }
        }}
      >
        <SelectTrigger
          className="w-[105px] h-10 px-3 border border-surface-200/50 dark:border-[#434939] bg-surface-50/50 dark:bg-[#1A1C1E]/50 backdrop-blur-md hover:bg-surface-200/50 dark:hover:bg-[#2F3133]/50 focus:outline-none focus:ring-2 focus:ring-primary shrink-0"
          title="Select Language"
        >
          <div className="flex items-center gap-2">
            {currentLanguage === "en" ? (
              <UkFlag size={18} style={{ borderRadius: "50%", overflow: "hidden" }} />
            ) : (
              <KsaFlag size={18} style={{ borderRadius: "50%", overflow: "hidden" }} />
            )}
            <span className="font-body text-xs font-semibold uppercase text-surface-900 dark:text-white">
              {currentLanguage === "en" ? "EN" : "AR"}
            </span>
          </div>
        </SelectTrigger>
        <SelectContent className="bg-white dark:bg-[#1A1C1E] border border-surface-200/50 dark:border-[#434939] rounded-xl shadow-modal min-w-[120px] p-1">
          <SelectItem value="en">
            <div className="flex items-center gap-2 dark:text-white">
              <UkFlag size={18} style={{ borderRadius: "50%", overflow: "hidden" }} />
              <span className="font-body text-xs font-semibold">EN</span>
            </div>
          </SelectItem>
          <SelectItem value="ar">
            <div className="flex items-center gap-2 dark:text-white">
              <KsaFlag size={18} style={{ borderRadius: "50%", overflow: "hidden" }} />
              <span className="font-body text-xs font-semibold">عربي</span>
            </div>
          </SelectItem>
        </SelectContent>
      </Select>
      {/* 
      <Button
        variant="ghost"
        size="icon"
        onClick={toggleTheme}
        className="rounded-full w-10 h-10 bg-surface-50/50 dark:bg-[#1A1C1E]/50 backdrop-blur-md hover:bg-surface-200/50 dark:hover:bg-[#2F3133]/50 text-surface-900 dark:text-white border border-surface-200/50 dark:border-[#434939]"
        title="Toggle Theme"
      >
        {resolvedTheme === "dark" ? <Moon className="w-4 h-4" /> : <Sun className="w-4 h-4" />}
      </Button>
      */}
    </div>
  );
}
